// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSnackbar-Action_cls1__VsU3L","cls2":"VeloSnackbar-Action_cls2__tM-i4 VeloSnackbar-Action_cls1__VsU3L"};